import styled from "styled-components";

const variantStyles = (theme, variant = "link") =>
  ({
    link: {
      gap: "8px",
      fontWeight: "400",
      lineHeight: "150%",
      padding: 0,
      color: theme.color.brandPrimary.light,
      textDecoration: "underline",
      background: "transparent",

      span: {
        textAlign: "start",
        flex: 1,
      },

      svg: {
        width: "28px",
        height: "28px",
      },
    },
    outline: {
      width: "100%",
      borderRadius: "8px",
      background: theme.color.neutral["08"],
      border: "1px solid",
      fontWeight: "700",
      color: theme.color.brandPrimary.light,
      borderColor: theme.color.brandPrimary.light,
      padding: "16px 36px",

      svg: {
        display: "none",

        [theme.breakpoint.lg]: {
          display: "inherit",
        },
      },
    },
  }[variant]);

const variantSize = (theme, size = "default") =>
  ({
    default: {
      fontSize: "14px",

      [theme.breakpoint.lg()]: {
        fontSize: "16px",
      },
    },
    lg: {
      fontSize: "18px",

      [theme.breakpoint.lg()]: {
        fontSize: "20px",
      },
    },
  }[size]);

export const ButtonContainer = styled.button(({ theme, $variant, size }) => ({
  display: "flex",
  border: "none",
  cursor: "pointer",

  "&:hover": {
    filter: "brightness(.9)",
  },
  ...variantStyles(theme, $variant),
  ...variantSize(theme, size),
}));
